import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ArrayContainsObjectWithPropertyBaseValueConverter {
    toView(array, configuration) {
        if (ObjectHelper.IsNullOrUndefined(array) || array.length <= 0)
        {
            return false;
        }
        return (array.filter((item) => item[configuration.propertyName] == configuration.value).length > 0)
    }
}